<div class="viewer" style="margin-top: 10px">
  @if(dualSystem()) {
      <div><img style="width:48%" [src]="currentImage()" class="image" /><img  style="width:48%;margin-left: 5px;" [src]="currentImage_R()" class="image" /></div>
  } @else {
    <img [src]="currentImage()" class="image" />
  }


  <div class="info">Km: {{ currentKm() | number: '1.3-3' }}</div>

  <ngx-slider
    [value]="currentIndex()"
    [options]="slideroptions"
    (valueChange)="onSliderChange($event)"
    style="padding-left: 10px; padding-right: 20px"></ngx-slider>

  <div class="btn-group">
    <button class="btn" (click)="play()">▶ Play</button>
    <button class="btn" (click)="stop()">⏹ Stop</button>
  </div>
</div>
